
import { useState } from "react";
import { useWorksheetManagement } from "@/hooks/worksheet";
import { Worksheet } from "@/hooks/worksheet/useWorksheetAPI";
import { WorksheetFormValues } from "./worksheetFormSchema";

export const useWorksheetTable = (itemsPerPage = 20) => {
  const {
    worksheets,
    isLoading,
    currentPage,
    setCurrentPage,
    totalPages,
    searchQuery,
    setSearchQuery,
    sortField,
    sortDirection,
    handleSort,
    subjectFilter,
    setSubjectFilter,
    subjects,
    updateWorksheet,
    createWorksheet,
    deleteWorksheet
  } = useWorksheetManagement(itemsPerPage);

  const [editingWorksheet, setEditingWorksheet] = useState<Worksheet | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('th-TH', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Handle the edit button click
  const handleEditClick = (worksheet: Worksheet) => {
    setEditingWorksheet(worksheet);
    setIsEditDialogOpen(true);
  };

  // Handle the save edit
  const handleSaveEdit = async (editedData: WorksheetFormValues) => {
    if (!editingWorksheet) return;
    
    await updateWorksheet(editingWorksheet.id, editedData);
    setIsEditDialogOpen(false);
  };

  // Handle creating a new worksheet
  const handleCreateWorksheet = async (worksheetData: WorksheetFormValues) => {
    await createWorksheet(worksheetData);
    setIsCreateDialogOpen(false);
  };

  // Handle confirming delete
  const handleDeleteWorksheet = async (id: number) => {
    await deleteWorksheet(id);
  };

  return {
    worksheets,
    isLoading,
    currentPage,
    setCurrentPage,
    totalPages,
    searchQuery,
    setSearchQuery,
    sortField,
    sortDirection,
    handleSort,
    subjectFilter,
    setSubjectFilter,
    subjects,
    editingWorksheet,
    isEditDialogOpen,
    setIsEditDialogOpen,
    isCreateDialogOpen,
    setIsCreateDialogOpen,
    formatDate,
    handleEditClick,
    handleSaveEdit,
    handleCreateWorksheet,
    handleDeleteWorksheet
  };
};
